import PropTypes from "prop-types";
import React from "react";
import { Mutation } from "react-apollo";

import {
  CREATE_STORYSECTION,
  DELETE_STORYSECTION,
  GET_STORIES,
  UPDATE_STORYSECTION,
} from "../../gql";

import Accordion from "../../components/Accordion";
import Throbber from "../../components/Throbber";
import SubStorySections from "./SubStorySections";

import roundPlus from "./../../../images/icons/round-plus-white.svg";

class StorySections extends React.Component {
  constructor() {
    super();
    this.state = {
      storySectionUpdate: {},
      publishIsUpToDate: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { published } = this.props;

    if (!published && prevProps.published) {
      this.setState({
        publishIsUpToDate: false,
      });
    }

    if (published && !prevProps.published) {
      this.setState({
        publishIsUpToDate: true,
      });
    }
  }

  createStorySection(createStorySection, storySections) {
    const {
      storyArticleId,
      app,
      languageCode,
      activatePublishButton,
      activateUnpublishedAlert,
    } = this.props;

    const orderIndex =
      storySections.length > 0
        ? storySections[storySections.length - 1].meta.displayOrder + 1
        : 0;

    createStorySection({
      variables: {
        title: "",
        subtitle: "",
        storyArticleId: storyArticleId,
        languageCode: languageCode,
        app: app,
        displayOrder: orderIndex,
      },
    });
    activatePublishButton();
    activateUnpublishedAlert();
  }

  submitUpdate(updateStorySection) {
    const { activatePublishButton, activateUnpublishedAlert } = this.props;
    const { storySectionUpdate } = this.state;
    updateStorySection({
      variables: storySectionUpdate,
    });
    this.setState({
      storySectionUpdate: {},
    });
    activatePublishButton();
    activateUnpublishedAlert();
  }

  onChangeHandle(event, id, updateStorySection) {
    const { app, languageCode } = this.props;
    const name = event.target.name;
    const value = event.target.value;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.submitUpdate(updateStorySection), 500);

    this.setState((prevState) => {
      if (
        prevState.storySectionUpdate &&
        prevState.storySectionUpdate.id === id
      ) {
        return {
          storySectionUpdate: {
            ...this.state.storySectionUpdate,
            id,
            [name]: value,
          },
        };
      }
      return {
        storySectionUpdate: {
          app,
          languageCode,
          published: false,
          id,
          [name]: value,
        },
      };
    });
  }

  deleteStorySection(id, deleteStorySection) {
    const { activatePublishButton, activateUnpublishedAlert } = this.props;
    if (confirm("Are you sure you want to delete this storySection?")) {
      deleteStorySection({
        variables: { id },
      });
      activatePublishButton();
      activateUnpublishedAlert();
    }
  }

  updateDisplayOrder(id, order, updateFunc) {
    const {
      app,
      languageCode,
      activatePublishButton,
      activateUnpublishedAlert,
    } = this.props;

    updateFunc({
      variables: {
        id,
        app,
        languageCode,
        published: false,
        displayOrder: order,
      },
    });
    activatePublishButton();
    activateUnpublishedAlert();
  }

  publishNotification() {
    const { activatePublishButton } = this.props;
    const { publishIsUpToDate } = this.state;

    if (publishIsUpToDate === null) {
      activatePublishButton();
    } else if (publishIsUpToDate) {
      return;
    }

    return (
      <div className="notification notification--warning">
        <p className="notification__description">
          The content below has not been published yet.
        </p>
      </div>
    );
  }

  render() {
    const {
      storySections,
      app,
      languageCode,
      published,
      activatePublishButton,
      activateUnpublishedAlert,
    } = this.props;

    return (
      <div>
        {storySections
          .sort((a, b) => a.meta.displayOrder - b.meta.displayOrder)
          .map((storySection) => (
            <Mutation
              key={storySection.id}
              mutation={DELETE_STORYSECTION}
              refetchQueries={[
                {
                  query: GET_STORIES,
                  variables: {
                    languageCode: languageCode,
                    app: app,
                  },
                },
              ]}
            >
              {(deleteStorySection, { loading, error }) => (
                <div className="relative-block">
                  {error && (
                    <p className="full-width center-align">{error.message}</p>
                  )}
                  {!storySection.availability.published &&
                    this.publishNotification()}
                  <Mutation
                    mutation={UPDATE_STORYSECTION}
                    refetchQueries={[
                      {
                        query: GET_STORIES,
                        variables: {
                          languageCode: languageCode,
                          app: app,
                        },
                      },
                    ]}
                  >
                    {(updateStorySection) => (
                      <Accordion
                        id={storySection.id}
                        title={storySection.title}
                        subtitle={storySection.subtitle}
                        twoHeaderInputs
                        enableOrdering
                        displayOrder={storySection.meta.displayOrder}
                        siblingAccordions={storySections}
                        updateDisplayOrder={(id, order) =>
                          this.updateDisplayOrder(id, order, updateStorySection)
                        }
                        deleteAccordion={() =>
                          this.deleteStorySection(
                            storySection.id,
                            deleteStorySection
                          )
                        }
                        onChanges={(event) =>
                          this.onChangeHandle(
                            event,
                            storySection.id,
                            updateStorySection
                          )
                        }
                      >
                        <SubStorySections
                          storySectionId={storySection.id}
                          subStorySections={storySection.subStorySections}
                          languageCode={languageCode}
                          published={published}
                          app={app}
                          activatePublishButton={activatePublishButton}
                          activateUnpublishedAlert={activateUnpublishedAlert}
                        />
                      </Accordion>
                    )}
                  </Mutation>
                  <Throbber
                    hidden={!loading}
                    loadingText="Deleting storySection..."
                  />
                </div>
              )}
            </Mutation>
          ))}
        <Mutation
          mutation={CREATE_STORYSECTION}
          refetchQueries={[
            {
              query: GET_STORIES,
              variables: {
                languageCode: languageCode,
                app: app,
              },
            },
          ]}
        >
          {(createStorySection, { loading, error }) => (
            <div className="full-width right-align relative-block">
              <Throbber
                hidden={!loading}
                loadingText="Creating storySection..."
              />
              {error && (
                <p className="full-width center-align">{error.message}</p>
              )}
              <button
                className="button button--small button--icon-text"
                disabled={loading}
                onClick={() =>
                  this.createStorySection(createStorySection, storySections)
                }
              >
                <img
                  src={roundPlus}
                  alt="Add new storySection"
                  className="button__icon"
                />
                Add new storySection
              </button>
            </div>
          )}
        </Mutation>
      </div>
    );
  }
}

StorySections.propTypes = {
  storySections: PropTypes.array.isRequired,
  storyArticleId: PropTypes.string.isRequired,
  languageCode: PropTypes.string.isRequired,
  published: PropTypes.bool.isRequired,
  app: PropTypes.string.isRequired,
  activatePublishButton: PropTypes.func.isRequired,
  activateUnpublishedAlert: PropTypes.func.isRequired,
};

export default StorySections;
